import React, { useEffect, useState } from "react";
import * as R from "ramda";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { validateValue } from "../../utils/utils";
import { idx_data_axistilt } from "../db/datafixtures/datafixtures";
import questionLogo from "../../images/Question_Mark_Icon.svg";
import feedbackTheme from "../../theme/feedback";

const rowSectionStyle = {
  "--bs-gutter-x": "0",
  display: "flex",
  flexWrap: "nowrap",
};

const tiltStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
};

const tableContainerStyle = {
  display: "flex",
  padding: "10px",
};

const backgroundBlock = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "center",
};

const questionLogoStyle = {
  width: "10px",
  height: "10px",
  padding: "0",
  margin: "0 7px 0 0",
};

const Button = styled.button`
  display: inline-block;
  margin: 0;
  width: 40px;
  height: 30px;
  background: ${(props) =>
    props.hand === "left_hander" && props.active === true
      ? props.theme.color.error
      : props.active === true
      ? props.theme.color.border
      : props.theme.color.surface};
  color: ${(props) =>
    props.active === true
      ? props.theme.color.primaryDark
      : props.theme.color.primary};
  border: 1px solid ${(props) => props.theme.color.border};
  opacity: 1;
  font-size: 12px;
  font-weight: 900;

  @media only screen and (max-width: 991px) {
    font-size: ${(props) => (props.exception === true ? "9px" : "12px")};
  }

  ${(props) =>
    props.pap &&
    css`
      font-size: 20px;
      font-weight: bold;
      text-transform: uppercase;
      min-height: 42px;
    `}

  ${(props) =>
    props.oneColumns &&
    css`
      width: 100%;

      @media only screen and (max-width: 1163px) {
        max-width: 1024px;
      }
      @media only screen and (max-width: 991px) {
        max-width: 100%;
      }
    `}
  ${(props) =>
    props.twoColumns &&
    css`
      width: 50%;

      @media only screen and (max-width: 1163px) {
        max-width: 512px;
      }

      @media only screen and (max-width: 991px) {
        max-width: 50%;
      }

      @media only screen and (max-width: 1600px) and (orientation: portrait) {
        max-width: 50%;
      }
    `}
    ${(props) =>
    props.threeColumns &&
    css`
      width: 33.33%;
      line-height: revert;
      font-weight: 900;
      height: 32px;

      @media only screen and (max-width: 1163px) {
        max-width: 341.33px;
      }

      @media only screen and (max-width: 991px) {
        max-width: 33.33%;
      }
      @media only screen and (max-width: 1600px) and (orientation: portrait) {
        max-width: 33.33%;
      }
    `}
    ${(props) =>
    props.fourColumns &&
    css`
      max-width: 70px;
      width: 25%;

      @media only screen and (max-width: 1163px) {
        max-width: 256px;
      }

      @media only screen and (max-width: 991px) {
        max-width: 25%;
        font-size: 9px;
      }
      @media only screen and (max-width: 1600px) and (orientation: portrait) {
        max-width: 25%;
        font-size: 9px;
      }
    `}
    
    &:hover {
    background: ${(p) => p.theme.color.primary};
    color: ${(p) => p.theme.color.surface};
  }
`;

const Section = styled.div`
  background: ${(p) => p.theme.color.surface} 0% 0% no-repeat padding-box;
  border: 1px solid ${(p) => p.theme.color.border};
  opacity: 1;
  display: flex;
  width: 100%;
  margin: 0px 0 4px 0;
  align-items: center;
  justify-content: center;
  padding: 0;

  ${(props) =>
    props.primary &&
    css`
      @media only screen and (max-width: 900px) and (orientation: portrait) {
        padding: 0;
        width: auto;
      }
    `}
  ${(props) =>
    props.block &&
    css`
      flex-direction: column;
    `}
    ${(props) =>
    props.blockException &&
    css`
      margin: ${(props) =>
        props.bottom === true ? "0 0 4px 0;" : "4px 0 0 0;"};

      @media only screen and (max-width: 512px) and (orientation: portrait) {
      }
    `}
`;

const DescriptionText = styled.span`
  font-size: ${(props) => (props.tittle === true ? "14px;" : "9px;")};
  letter-spacing: 0px;
  opacity: 1;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  color: ${(props) =>
    props.tittle === true ? `${props.theme.color.primary};` : "inherit;"};
  margin-left: 3px;
  font-weight: ${(props) => (props.tittle === true ? "900;" : "300;")};

  ${(props) =>
    props.tableDescription &&
    css`
      justify-content: flex-start;
      align-items: center;
      margin: 1vh -5em 1vh 0;
    `}
  ${(props) =>
    props.table &&
    css`
      justify-content: flex-start;
      align-items: center;
      color: ${(p) => p.theme.color.textMuted};

      text-orientation: upright;
      transform: rotate(270deg);
      transform-origin: left;
      font-size: 12px;
      margin: 15px 0px -15px 10px;
    `}
    ${(props) =>
    props.recommendedValue &&
    css`
      font-size: ${(props) => (props.isTilt === "tilt" ? "14px;" : "10px;")};
      justify-content: flex-start;
      align-items: center;
      color: ${(p) => p.theme.color.textMuted};
      width: 100%;
    `}
`;

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #ffffff;
    box-shadow: inset 0 4px 0 ${(p) => p.theme.color.primary},
      0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: ${(p) => p.theme.radius.md};
    border: none;
  }
  .modal-header {
    border-bottom: 1px solid ${(p) => p.theme.color.border};
    padding: calc(${(p) => p.theme.spacing.md} + 4px)
      ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
  }
  .modal-body {
    padding: ${(p) => p.theme.spacing.md};
    overflow: visible;
  }
`;

const ModalTitle = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeLg};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
  line-height: 1.2;
`;

const InfoCard = styled.div`
  background: ${(p) => p.theme.color.surfaceAlt};
  border-radius: ${(p) => p.theme.radius.md};
  padding: ${(p) => p.theme.spacing.md};
`;

const BowlerDataModal = (props) => {
  const {
    showData,
    setShowData,
    bowler,
    isReadOnly,
    setCustomer,
    isRightHander,
    specsheetSVGClick,
  } = props;
  const { t } = useTranslation();

  const values = {
    tables: {
      hand: bowler.hand,
      style: bowler.style || "traditional",
      pap: `${validateValue(bowler.pap_h)} X ${validateValue(bowler.pap_v)} ${
        validateValue(bowler.pap_u_d || bowler.pap_ud) === "Up"
          ? "▲"
          : validateValue(bowler.pap_u_d || bowler.pap_ud) === "Down"
          ? "▼"
          : validateValue(bowler.pap_u_d || bowler.pap_ud) === "-"
          ? "-"
          : ""
      }`,
      axis_rot: bowler.axis_rot,
      axis_tilt: bowler.axis_tilt,
      ball_speed: bowler.ball_speed || "average",
      rev_rate: bowler.rev_rate || "average",
    },
  };

  const {
    tables: { hand, style, pap, axis_rot, axis_tilt, ball_speed, rev_rate },
  } = values;

  const handleInputChange = ({ target }) => {
    if (isReadOnly) {
      return;
    }
    const id = target.id;
    const name = target.name;
    let temp = { ...values };
    Object.entries(temp).forEach((element) => {
      if (element[0] === id) {
        if (target.value === "true") {
          element[1][name] = true;
          setCustomer({ bowler: { ...bowler, [name]: true } });
        } else if (target.value === "false") {
          element[1][name] = false;
          setCustomer({ bowler: { ...bowler, [name]: false } });
        } else {
          element[1][name] = target.value;
          setCustomer({ bowler: { ...bowler, [name]: target.value } });
        }
      }
    });
  };

  const clickableRectOnClickHandler = (field) => {
    let openDropdown = field;
    if (!isRightHander) {
      if (field.indexOf("f1_") >= 0) {
        openDropdown = field.replace("f1_", "f2_");
      } else if (field.indexOf("f2_") >= 0) {
        openDropdown = field.replace("f2_", "f1_");
      }
    }
    specsheetSVGClick({ openDropdown });
  };

  const getTiltRow = (tilt) => {
    if (tilt === "13.5" || tilt === "13.25" || tilt === "13") {
      return 1;
    } else if (tilt === "12.75" || tilt === "12.5" || tilt === "12") {
      return 2;
    } else if (tilt === "11.5" || tilt === "11" || tilt === "10.5") {
      return 3;
    } else if (tilt === "10" || tilt === "9.5" || tilt === "9") {
      return 4;
    } else {
      return 5;
    }
  };

  const getAxisTiltList = () => {
    const tiltsComp = [];
    for (let i = 1; i < idx_data_axistilt.length; i += 3) {
      const getTilt = (idx) => {
        const tilts = [];
        for (let j = idx; j < idx_data_axistilt.length && j < idx + 3; j++) {
          tilts.push(
            <Button
              onClick={handleInputChange}
              active={
                axis_tilt === idx_data_axistilt[j].tilt_measure ? true : false
              }
              name="axis_tilt"
              value={idx_data_axistilt[j].tilt_measure}
              id="tables"
            >
              {idx_data_axistilt[j].tilt_measure}"
            </Button>
          );
        }
        return tilts;
      };

      const getTitle = (idx) => {
        if (idx === 1) {
          return <DescriptionText table>{t("form.label.low")}</DescriptionText>;
        }
        if (idx === 7) {
          return <DescriptionText table>{t("form.label.med")}</DescriptionText>;
        }
        if (idx === idx_data_axistilt.length - 3) {
          return (
            <DescriptionText table>{t("form.label.high")}</DescriptionText>
          );
        }
      };

      tiltsComp.push(
        <div className="row" style={rowSectionStyle}>
          {getTilt(i)}
          {getTitle(i)}
        </div>
      );
    }

    return tiltsComp;
  };

  const getTiltDegree = (tilt) => {
    const tiltObj = R.find(R.propEq("tilt_measure", tilt), idx_data_axistilt);

    return tiltObj ? tiltObj.tilt_deg : "";
  };

  return (
    <div>
      <StyledModal
        show={showData}
        onHide={() => setShowData(false)}
        size="md"
        centered
        style={{ margin: 0 }}
      >
        <Modal.Header closeButton>
          <ModalTitle>{t("form.label.bowlerData")}</ModalTitle>
        </Modal.Header>
        <Modal.Body>
          <InfoCard>
          <div className="col-12 col-lg-12">
            <div className="row" style={tableContainerStyle}>
              <Section block>
                <div style={backgroundBlock}>
                  <Button
                    twoColumns
                    onClick={handleInputChange}
                    active={hand === "left_hander" ? true : false}
                    name="hand"
                    value="left_hander"
                    id="tables"
                    hand={hand}
                  >
                    {t("form.label.left_handed")}
                  </Button>
                  <Button
                    twoColumns
                    onClick={handleInputChange}
                    active={hand === "right_hander" ? true : false}
                    name="hand"
                    value="right_hander"
                    id="tables"
                    hand={hand}
                  >
                    {t("form.label.right_handed")}
                  </Button>
                </div>
              </Section>
              <Section block>
                <div style={backgroundBlock}>
                  <Button
                    twoColumns
                    onClick={handleInputChange}
                    active={style === "traditional" ? true : false}
                    name="style"
                    value="traditional"
                    id="tables"
                  >
                    {t("form.label.traditional")}
                  </Button>
                  <Button
                    twoColumns
                    margin={true}
                    onClick={handleInputChange}
                    active={style === "two_handed" ? true : false}
                    name="style"
                    value="two_handed"
                    id="tables"
                  >
                    {t("form.label.two_handed")}
                  </Button>
                </div>
                <div style={backgroundBlock}>
                  <Button
                    twoColumns
                    margin={true}
                    onClick={handleInputChange}
                    active={style === "backup" ? true : false}
                    name="style"
                    value="backup"
                    id="tables"
                  >
                    {t("form.label.backup")}
                  </Button>
                  <Button
                    twoColumns
                    exception={true}
                    onClick={handleInputChange}
                    active={style === "helicopter_spinner" ? true : false}
                    name="style"
                    value="helicopter_spinner"
                    id="tables"
                    style={{ fontSize: 9 }}
                  >
                    {t("form.label.helicopter_spinner")}
                  </Button>
                </div>
                <div style={backgroundBlock}>
                  <Button
                    twoColumns
                    margin={true}
                    onClick={handleInputChange}
                    active={style === "full-roller" ? true : false}
                    name="style"
                    value="full-roller"
                    id="tables"
                  >
                    {t("form.label.full-roller")}
                  </Button>
                  <Button
                    twoColumns
                    exception={true}
                    onClick={handleInputChange}
                    active={style === "thumbless" ? true : false}
                    name="style"
                    value="thumbless"
                    id="tables"
                    style={{ fontSize: 9 }}
                  >
                    {t("form.label.thumbless")}
                  </Button>
                </div>
              </Section>
              <Section>
                <Button
                  oneColumns
                  reduceSize
                  pap
                  onClick={() => {
                    !isReadOnly && clickableRectOnClickHandler("pap");
                  }}
                  active={pap === "pap" ? true : false}
                  name="pap"
                  value="pap"
                  id="tables"
                >
                  {t("form.label.pap")}: {pap}
                </Button>
              </Section>
              <Section>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={axis_rot === "0-30" ? true : false}
                  name="axis_rot"
                  value="0-30"
                  id="tables"
                >
                  0-30°
                  <DescriptionText>
                    {" "}
                    {t("form.label.axis_rotation")}{" "}
                  </DescriptionText>
                </Button>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={axis_rot === "30-60" ? true : false}
                  name="axis_rot"
                  value="30-60"
                  id="tables"
                >
                  30-60°
                  <DescriptionText>
                    {" "}
                    {t("form.label.axis_rotation")}{" "}
                  </DescriptionText>
                </Button>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={axis_rot === "60-90" ? true : false}
                  name="axis_rot"
                  value="60-90"
                  id="tables"
                >
                  60-90°
                  <DescriptionText>
                    {" "}
                    {t("form.label.axis_rotation")}{" "}
                  </DescriptionText>
                </Button>
              </Section>
              <DescriptionText tableDescription>
                <img
                  style={questionLogoStyle}
                  src={questionLogo}
                  alt="question logo style"
                />
                {t("form.label.axis_tilt_by_track_tangent")}
              </DescriptionText>
              <Section>
                <div className="col-6">{getAxisTiltList()}</div>
                <div className="col-6" style={tiltStyle}>
                  <DescriptionText tittle={true}>
                    {t("form.label.tilt")}:
                  </DescriptionText>
                  <DescriptionText recommendedValue isTilt="tilt">
                    {getTiltDegree(axis_tilt)}°
                  </DescriptionText>
                  <DescriptionText tittle={true}>
                    {t("form.label.suggestion")}:
                  </DescriptionText>
                  <DescriptionText recommendedValue>
                    {t(`tilt_suggestion.row${getTiltRow(axis_tilt)}`)}
                  </DescriptionText>
                </div>
              </Section>
              <Section blockException>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={ball_speed === "slow" ? true : false}
                  name="ball_speed"
                  value="slow"
                  id="tables"
                >
                  {t("form.label.slow")}
                  <DescriptionText> {t("form.label.speed")} </DescriptionText>
                </Button>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={ball_speed === "average" ? true : false}
                  name="ball_speed"
                  value="average"
                  id="tables"
                >
                  {t("form.label.average")}
                  <DescriptionText> {t("form.label.speed")} </DescriptionText>
                </Button>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={ball_speed === "fast" ? true : false}
                  name="ball_speed"
                  value="fast"
                  id="tables"
                >
                  {t("form.label.fast")}
                  <DescriptionText> {t("form.label.speed")} </DescriptionText>
                </Button>
              </Section>
              <Section blockException bottom={true}>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={rev_rate === "low" ? true : false}
                  name="rev_rate"
                  value="low"
                  id="tables"
                >
                  {t("form.label.low")}
                  <DescriptionText>
                    {" "}
                    {t("form.label.rev_rate")}{" "}
                  </DescriptionText>
                </Button>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={rev_rate === "average" ? true : false}
                  name="rev_rate"
                  value="average"
                  id="tables"
                >
                  {t("form.label.average")}
                  <DescriptionText>
                    {" "}
                    {t("form.label.rev_rate")}{" "}
                  </DescriptionText>
                </Button>
                <Button
                  threeColumns
                  onClick={handleInputChange}
                  active={rev_rate === "high" ? true : false}
                  name="rev_rate"
                  value="high"
                  id="tables"
                >
                  {t("form.label.high")}
                  <DescriptionText>
                    {" "}
                    {t("form.label.rev_rate")}{" "}
                  </DescriptionText>
                </Button>
              </Section>
            </div>
          </div>
          </InfoCard>
        </Modal.Body>
      </StyledModal>
    </div>
  );
};

export default BowlerDataModal;
